export default __webpack_public_path__ + "static/media/s34d_bg.608d36aa.png";